import { useEffect, useRef, useState } from 'react'
import ReactGA from 'react-ga4'

/**
 * Custom hook to initialize Google Analytics
 * @returns {boolean} - Whether GA is initialized
 */
export const useGoogleAnalytics = () => {
  const isInitialized = useRef(false)
  const [initialized, setInitialized] = useState(false)

  useEffect(() => {
    if (!isInitialized.current) {
      const MEASUREMENT_ID = process.env.REACT_APP_MEASUREMENG_ID
      if (MEASUREMENT_ID) {
        ReactGA.initialize(MEASUREMENT_ID, {
          gaOptions: {
            debug_mode: true,
          },
        })
        isInitialized.current = true
        setInitialized(true)
      }
    }
  }, [])

  return initialized
}

/**
 * Send event to Google Analytics
 * @param {string} eventName - Name of the event
 * @param {Object} eventParams - Event parameters
 */
export const sendGAEvent = (eventName, eventParams) => {
  ReactGA.event(eventName, {
    ...eventParams,
    debug_mode: true,
  })
}

/**
 * Send pageview to Google Analytics
 * @param {string} pagePath - Path of the page
 * @param {Object} options - Optional parameters like user_id, uid
 */
export const sendGAPageView = (pagePath, options = {}) => {
  ReactGA.send({
    hitType: 'pageview',
    page: pagePath,
    ...(options.user_id && { user_id: options.user_id }),
    ...(options.uid && { uid: options.uid }),
    debug_mode: true,
  })
}
